var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgData = function SvgData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1.938 1.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.063,
    cy: 7.125,
    fill: "currentColor",
    fillRule: "nonzero",
    opacity: 0.2,
    rx: 13.063,
    ry: 7.125
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.063,
    cy: 7.125,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.398,
    rx: 13.063,
    ry: 7.125
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.398,
    d: "M0 7.125v7.125c0 3.934 5.848 7.125 13.063 7.125 7.214 0 13.062-3.191 13.062-7.125V7.125"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.398,
    d: "M0 14.25v7.125C0 25.309 5.848 28.5 13.063 28.5c7.214 0 13.062-3.191 13.062-7.125V14.25"
  }))));
};
export default SvgData;